
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppLoadingCircular extends Vue {
    @Prop({ default: false }) private visible?: boolean
}
